import { InventoryTransactionDetailPage } from "@/features/inventory-transaction/pages/InventoryTransactionDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-transaction/$id/detail")(
	{
		beforeLoad({ context }) {
			if (
				!context.authAdapter.can({
					permissions: ["inventory_transaction.view"],
				})
			) {
				throw redirect({ to: "/403" });
			}
		},
		component: InventoryTransactionDetailPage,
	},
);
